import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { FHEListProduct } from 'data/components/index';
import { WifiIcon } from 'data/common/iconsvg/index';

class OneWifiItem extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        wifi: PropTypes.object.isRequired
    };

    _getIcon = () => {
        const { theme, classes, wifi } = this.props;
        return <WifiIcon level={wifi.signalLevel} color={theme.palette.primary.main} className={classes.icon} />;
    };

    render() {
        const { wifi } = this.props;
        const bssid = wifi.bssid.includes(':') ? wifi.bssid : wifi.bssid.match(/.{1,2}/g).join(':');
        return <FHEListProduct primary={wifi.ssid} secondary={bssid.toUpperCase()} icon={this._getIcon()} />;
    }
}

const styles = () => ({
    container: {
        flexDirection: 'row',
        paddingHorizontal: 15,
        paddingVertical: 5,
        alignItems: 'center'
    },
    icon: {
        marginRight: 20
    },
    texts: {
        fontSize: 19
    }
});

export default withStyles(styles, { withTheme: true })(OneWifiItem);



// WEBPACK FOOTER //
// ./data/components/OneWifiItem.js